<template>
  <div style="padding: 2rem; background: #fff; margin-top: 10px">
    <vxe-toolbar
      v-if="
        operateType === 'add' ||
        operateType === 'edit' ||
        operateType === 'renewal' ||
        operateType === 'changeInfo' ||
        operateType === 'changeSubject'
      "
    >
      <template v-slot:buttons>
        <vxe-button type="primary" class="vxe-btn-primary" @click="insertEvent">新增</vxe-button>
        <vxe-button
          type="primary"
          class="vxe-btn-delete"
          @click="handleDelete('rentFreeTable')"
          :style="'background-color:' + '#FE8783' + ';border:1px solid ' + '#FE8783'"
          >删除</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-table
      width="100%"
      align="left"
      show-header-overflow
      class="vxe-table-element"
      show-footer
      :auto-resize="true"
      border
      resizable
      show-overflow
      :data="rentFreeTableDate"
      :edit-config="editConfig"
      size="mini"
      ref="rentFreeTable"
      :max-height="$store.state.app.tableHeight"
      :edit-rules="rentFreeTableEditRules"
    >
      <vxe-table-column type="checkbox" width="60"></vxe-table-column>
      <vxe-table-column
        field="spaceAreaNo"
        title="片区"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.spaceAreaNo"
            clearable
            filterable
            @change="() => handleAreaChange(scope.row, scope, 'rentFreeTable')"
          >
            <el-option
              v-for="(item, index) in areaList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{
          transferSelect(row.spaceAreaNo, areaList, 'id', 'name')
        }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="spaceAssetNo"
        title="资产名称"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.spaceAssetNo"
            clearable
            filterable
            @change="() => handleAssetsChange(scope.row, scope, 'rentFreeTable')"
          >
            <el-option
              v-for="(item, index) in scope.row.assetsList || []"
              :key="index"
              :label="item.name"
              :value="item.id"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{
          transferSelect(row.spaceAssetNo, row.assetsList, 'id', 'name')
        }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="spaceUnitNo"
        title="单元（楼栋）"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.spaceUnitNo"
            clearable
            filterable
            @change="() => handleUnitChange(scope.row, scope, 'rentFreeTable')"
          >
            <el-option
              v-for="(item, index) in scope.row.unitList || []"
              :key="index"
              :label="item.name"
              :value="item.id"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{
          transferSelect(row.spaceUnitNo, row.unitList, 'id', 'name')
        }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="spaceFloorNo"
        title="楼层"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.spaceFloorNo"
            clearable
            filterable
            @change="() => handleFloorChange(scope.row, scope, 'rentFreeTable')"
          >
            <el-option
              v-for="(item, index) in scope.row.spaceFloorList || []"
              :key="index"
              :label="item.name"
              :value="item.id"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{
          transferSelect(row.spaceFloorNo, row.spaceFloorList, 'id', 'name')
        }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="spaceRoomNo"
        title="房号"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.spaceRoomNo"
            clearable
            filterable
            @change="() => handleRoomChange(scope.row)"
          >
            <el-option
              v-for="(item, index) in scope?.row?.roomList || []"
              :key="index"
              :label="item.name"
              :value="item.id"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{
          transferSelect(row.spaceRoomNo, row.roomList, 'id', 'name')
        }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="freeRentType"
        title="免租期类型"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:edit="scope">
          <el-select v-model="scope.row.freeRentType" clearable filterable>
            <el-option
              v-for="(item, index) in freeRentTypeList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{
          transferSelect(row.freeRentType, freeRentTypeList)
        }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="freeRentStart"
        title="免租开始日"
        width="150"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-date-picker
            v-model="scope.row.freeRentStart"
            value-format="yyyy-MM-dd"
            type="date"
            style="width: 100px"
            placeholder=""
            :picker-options="scope.row.pickerSettleOptions"
            @change="() => handleStartChange(scope.row)"
          >
          </el-date-picker>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="freeRentEnd"
        title="免租截止日"
        width="150"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-date-picker
            v-model="scope.row.freeRentEnd"
            value-format="yyyy-MM-dd"
            type="date"
            style="width: 100px"
            placeholder=""
            :picker-options="scope.row.pickerSettleOptions"
            @change="() => handleEndChange(scope.row)"
          >
          </el-date-picker>
        </template>
      </vxe-table-column>
      <vxe-table-column field="remark" title="备注" :edit-render="{ type: 'default' }">
        <template v-slot:edit="scope">
          <el-input v-model="scope.row.remark" maxlength="20" />
        </template>
      </vxe-table-column>
    </vxe-table>
    <!-- </el-card> -->
  </div>
</template>

<script>
  import leaseContractMixin from '@/pages/property/leaseContract/mixins/leaseContract';
  import { freeRentTypeList } from '../data';
  export default {
    name: 'rentFreeInfo',
    props: ['detailRentFreeTableData', 'leaseDateFrom', 'leaseDateUntil'],
    mixins: [leaseContractMixin],
    computed: {
      operateType() {
        return this.$route.query.type;
      },
      pickerSettleOptions() {
        return {
          disabledDate: (time) => {
            return time < new Date(this.startDate) - 8.64e7 || time > new Date(this.endDate);
          },
        };
      },
      rentFreeTableEditRules() {
        return {
          // spaceAreaNo: [
          //   {
          //     required: true,
          //     message: '请选择',
          //     trigger: 'blur',
          //   },
          // ],
          // spaceAssetNo: [
          //   {
          //     required: true,
          //     message: '请选择',
          //     trigger: 'blur',
          //   },
          // ],
          // freeRentType: [
          //   {
          //     required: true,
          //     message: '请选择',
          //     trigger: 'blur',
          //   },
          // ],
          // freeRentStart: [
          //   {
          //     required: true,
          //     message: '请选择',
          //     trigger: 'blur',
          //   },
          // ],
          // freeRentEnd: [
          //   {
          //     required: true,
          //     message: '请选择',
          //     trigger: 'blur',
          //   },
          // ],
        };
      },
    },
    data() {
      return {
        rentFreeTableDate: [],
        editConfig: {},
        freeRentTypeList,
        startDate: '',
        endDate: '',
        activeCollapses: ['1'],
      };
    },
    watch: {
      leaseDateFrom(newVal) {
        this.startDate = newVal;
        if (this.operateType === 'edit') {
          this.resetPickerSettleOptions();
        }
      },
      leaseDateUntil(newVal) {
        this.endDate = newVal;
        if (this.operateType === 'edit') {
          this.resetPickerSettleOptions();
        }
      },
      detailRentFreeTableData(newVal) {
        if (newVal) {
          this.dealDetailData(newVal);
        }
      },
    },
    created() {
      this.getArea();
    },
    mounted() {
      this.editConfig =
        this.operateType === 'add' ||
        this.operateType === 'edit' ||
        this.operateType === 'renewal' ||
        this.operateType === 'changeInfo' ||
        this.operateType === 'changeSubject'
          ? { trigger: 'dblclick', mode: 'row' }
          : {};
    },
    methods: {
      handleStartChange(row) {
        if (row.freeRentStart && row.freeRentEnd) {
          row.pickerSettleOptions = {
            disabledDate: (time) => {
              return (
                time < new Date(row.freeRentStart) - 8.64e7 || time > new Date(row.freeRentEnd)
              );
            },
          };
        } else if (row.freeRentStart && !row.freeRentEnd) {
          row.pickerSettleOptions = {
            disabledDate: (time) => {
              return time < new Date(row.freeRentStart) - 8.64e7 || time > new Date(this.endDate);
            },
          };
        } else if (!row.freeRentStart && row.freeRentEnd) {
          row.pickerSettleOptions = {
            disabledDate: (time) => {
              return time < new Date(this.startDate) - 8.64e7 || time > new Date(row.freeRentEnd);
            },
          };
        } else {
          row.pickerSettleOptions = {
            disabledDate: (time) => {
              return time < new Date(this.startDate) - 8.64e7 || time > new Date(this.endDate);
            },
          };
        }
        if (!row.spaceId) {
          return this.$message({
            showClose: true,
            message: '请选择免租空间',
            type: 'warning',
          });
        }
        if (!row.freeRentEnd) {
          return this.$message({
            showClose: true,
            message: '请选择免租截止日',
            type: 'warning',
          });
        }
        if (!row.freeRentStart) {
          return this.$message({
            showClose: true,
            message: '请选择免租开始日',
            type: 'warning',
          });
        }

        this.$emit('rentChange', row);
      },
      handleEndChange(row) {
        console.log(row, '1112233');
        if (row.freeRentStart && row.freeRentEnd) {
          row.pickerSettleOptions = {
            disabledDate: (time) => {
              return (
                time < new Date(row.freeRentStart) - 8.64e7 || time > new Date(row.freeRentEnd)
              );
            },
          };
        } else if (row.freeRentStart && !row.freeRentEnd) {
          row.pickerSettleOptions = {
            disabledDate: (time) => {
              return time < new Date(row.freeRentStart) - 8.64e7 || time > new Date(this.endDate);
            },
          };
        } else if (!row.freeRentStart && row.freeRentEnd) {
          row.pickerSettleOptions = {
            disabledDate: (time) => {
              return time < new Date(this.startDate) - 8.64e7 || time > new Date(row.freeRentEnd);
            },
          };
        } else {
          row.pickerSettleOptions = {
            disabledDate: (time) => {
              return time < new Date(this.startDate) - 8.64e7 || time > new Date(this.endDate);
            },
          };
        }
        if (!row.spaceId) {
          return this.$message({
            showClose: true,
            message: '请选择免租空间',
            type: 'warning',
          });
        }
        if (!row.freeRentStart) {
          return this.$message({
            showClose: true,
            message: '请选择免租开始日',
            type: 'warning',
          });
        }
        if (!row.freeRentEnd) {
          return this.$message({
            showClose: true,
            message: '请选择免租截止日',
            type: 'warning',
          });
        }
        this.$emit('rentChange', row);
      },
      async dealDetailData(list) {
        console.log(111111111);
        for (let item of list) {
          if (item.spaceAreaNo) {
            await this.getAssetsList(item);
          }
          if (item.spaceAssetNo) {
            await this.getUnitList(item);
          }
          if (item.spaceUnitNo) {
            await this.getSpaceFloorList(item);
          }
          if (item.spaceFloorNo) {
            await this.getRoomList(item);
          }
          if (item.freeRentStart && item.freeRentEnd) {
            await this.getPickerSettleOptions(item);
          }
        }
        this.rentFreeTableDate = list;
      },
      getPickerSettleOptions(item) {
        item.pickerSettleOptions = {
          disabledDate: (time) => {
            return (
              time < new Date(item.freeRentStart) - 8.64e7 || time > new Date(item.freeRentEnd)
            );
          },
        };
      },
      insertEvent() {
        console.log('insertEvent');
        this.$refs['rentFreeTable'].validate((valid) => {
          if (valid) {
            let record = {
              spaceAreaNo: '',
              spaceAssetNo: '',
              spaceUnitNo: '',
              spaceFloorNo: '',
              spaceRoomNo: '',
              freeRentType: '',
              freeRentStart: '',
              freeRentEnd: '',
              remark: '',
              pickerSettleOptions: this.pickerSettleOptions,
            };
            this.$refs.rentFreeTable
              .insert(record, -1)
              .then(({ row }) => this.$refs.rentFreeTable.setActiveRow(row));
          }
        });
      },
      handleDelete(tableType) {
        const selectedList = this.$refs[tableType].getSelectRecords(); // 或许选中数据
        if (selectedList.length < 1) {
          return this.$message({
            showClose: true,
            message: this.$t('goods.message.noChooseDel'),
            type: 'error',
          });
        }
        let arr = [];
        selectedList.map((item) => {
          arr.push({
            spaceId: item.spaceId,
            freeRentStart: item.freeRentStart,
            freeRentEnd: item.freeRentEnd,
          });
        });
        this.$confirmAction()
          .then(() => {
            this.$refs[tableType].removeSelecteds();
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('goods.message.delSuccess'),
            });
            this.$emit('deleteRentInfo', arr);
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('goods.message.unDel'),
            });
          });
      },
      resetPickerSettleOptions() {
        if (this.startDate && this.endDate) {
          this.rentFreeTableDate.map((item) => {
            item.pickerSettleOptions = {
              disabledDate: (time) => {
                return time < new Date(this.startDate) - 8.64e7 || time > new Date(this.endDate);
              },
            };
          });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .title {
    font-size: 20px;
    font-weight: 600;
  }
</style>
